import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import BookingSection from '../components/SaasPlatformsLanding/BookingSection'
import CampaignStrategy from '../components/SaasPlatformsLanding/CampaignStrategy'
import FAQ from '../components/SaasPlatformsLanding/FAQ'
import HowItWorks from '../components/SaasPlatformsLanding/HowItWorks'
import SaaSPlatformsHero from '../components/SaasPlatformsLanding/SaaSPlatformsHero'
import SocialProof from '../components/SaasPlatformsLanding/SocialProof'
import WhyOLM from '../components/SaasPlatformsLanding/WhyOLM'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'

const SAAS_PLATFORMS_FALLBACK_META = `
<meta name="description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
<meta property="og:title" content="Direct Mail Marketing That Works" />
<meta property="og:description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
`

export default function SaaSPlatforms({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header
                meta={data?.yoast_head || SAAS_PLATFORMS_FALLBACK_META}
                metaTitle="Direct Mail Marketing That Works"
            />
            <SaaSPlatformsHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .saas-platforms-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .saas-platforms-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .saas-platforms-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/saas-platforms')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
